import {
  HeartPulse, CalendarDays, Brain, Fingerprint, BrainCircuit, SlidersHorizontal,
  Baby, Briefcase, TrendingUp, Wallet, BookOpen, Shirt, Sparkles,
} from 'lucide-react';

// Shared skill metadata (id / name / icon / unlocked) used by both the mobile
// Life grid and the desktop sidebar. Keep in sync with buildSkills in LifeView.
export const SKILL_META = [
  { id: 'health', name: 'Health & Fitness', icon: HeartPulse, unlocked: true },
  { id: 'calendar', name: 'Calendar', icon: CalendarDays, unlocked: true },
  { id: 'memory', name: 'Memory', icon: Brain, unlocked: true },
  { id: 'personality', name: 'Personality', icon: Fingerprint, unlocked: true },
  { id: 'nexa', name: "NEXA's Mind", icon: BrainCircuit, unlocked: true },
  { id: 'settings', name: 'Settings', icon: SlidersHorizontal, unlocked: true },
  { id: 'kids', name: 'Kids', icon: Baby, unlocked: true },
  { id: 'work', name: 'Work', icon: Briefcase, unlocked: false },
  { id: 'business', name: 'Business', icon: TrendingUp, unlocked: true },
  { id: 'finance', name: 'Finance', icon: Wallet, unlocked: true },
  { id: 'journal', name: 'Journal', icon: BookOpen, unlocked: true },
  { id: 'styling', name: 'Styling', icon: Shirt, unlocked: true },
  { id: 'personal', name: 'Personal Growth', icon: Sparkles, unlocked: true },
];

export const ORDER_KEY = 'nexa_skill_order_v1';
export const DEFAULT_ORDER = [
  'health', 'calendar', 'memory', 'personality', 'nexa', 'settings',
  'kids', 'work', 'business', 'styling', 'personal',
];

// Favorites float to the top (keeping relative order); missing ids appended.
export const orderSkillIds = (order, favorites) => {
  const ids = SKILL_META.map((s) => s.id);
  const known = (order || []).filter((id) => ids.includes(id));
  const missing = ids.filter((id) => !known.includes(id));
  const base = [...known, ...missing];
  const favs = base.filter((id) => favorites.includes(id));
  const rest = base.filter((id) => !favorites.includes(id));
  return [...favs, ...rest];
};
